<template>
  <div class="fcc-mensagens-email">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :status="status"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
            :actions="actions"
            addFilter
            :items="listarMensagens"
          >
          </fccTable>
        </div>
      </div>
    </div>

    <fccModal
      :idModal="'modal-edit' + _uid"
      :titleModal="titleModal"
      size="lg"
      centered
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="submitTemplate()" autocomplete="off">
        <div class="row mb-4">
          <div class="col-md-6">
            <fccInput extraClasses="inputLabel" v-model="editarTemplate.chave" required
              >Chave</fccInput
            >
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-6">
            <fccInput extraClasses="inputLabel" v-model="editarTemplate.identificacao" required
              >Identificação</fccInput
            >
          </div>
          <div class="col-md-6">
            <fccInput extraClasses="inputLabel" v-model="editarTemplate.assunto" required
              >Assunto</fccInput
            >
          </div>
        </div>

        <b-form-group label="Cópia para" class="mb-4" label-for="cc">
          <b-form-tags
            input-id="cc"
            placeholder=""
            separator=" ,;"
            add-button-text="Adicionar"
            invalid-tag-text="E-mail inválido"
            v-model="ccTags"
            @input="(val) => converteCopia(val)"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            :tag-validator="validaEmail"
          />

          <template #invalid-feedback> Digite um e-mail válido! </template>

          <template #description>
            <div id="tags-validation-help">
              Digite e-mails separados por espaço, virgula ou ponto e vírgula...
            </div>
          </template>
        </b-form-group>

        <b-form-group label="Cópia oculta para" class="mb-4" label-for="cco">
          <b-form-tags
            input-id="cco"
            placeholder=""
            separator=" ,;"
            add-button-text="Adicionar"
            invalid-tag-text="E-mail inválido"
            v-model="ccoTags"
            @input="(val) => converteCopia(val, false)"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            :tag-validator="validaEmail"
          />
          <template #invalid-feedback> Digite um e-mail válido! </template>

          <template #description>
            <div id="tags-validation-help">
              Digite e-mails separados por espaço, virgula ou ponto e vírgula...
            </div>
          </template>
        </b-form-group>

        <fcc-select
          class="mb-4"
          placeholder="Selecione um template"
          labelField="identificacao"
          valueField="idtemplate"
          v-model="editarTemplate.idtemplate"
          :options="listarTemplates"
        >
          Template
        </fcc-select>
        Mensagem
        <fccEditor v-model="editarTemplate.mensagem"></fccEditor>

        <div class="row mt-2 mb-4">
          <div class="col">
            <fcc-button
              v-if="editarTemplate.idemail !== 0"
              icon="eye"
              title="Pré-visualizar o template"
              v-b-tooltip.hover
              :action="() => viewField(null, editarTemplate)"
            />
          </div>
          <div class="col text-right">
            <toggle-button v-model="editarTemplate.ativo" />
            Ativo
          </div>
        </div>

        <fcc-button classeAdd="w-100" tipo="submit">{{ labelsSystem.salvar }}</fcc-button>
      </form>
    </fccModal>
    <fccModal
      :idModal="'modal-view' + _uid"
      titleModal="Visualização da mensagem"
      size="lg"
      centered
      escondeFooter
    >
      <span v-html="showMensagem"></span>
    </fccModal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Mensagens de Emails',
      titleModal: '',
      titlePDF: 'Mensagens de Emails',
      listarMensagens: [],
      editarTemplate: {},
      showMensagem: '',
      ccTags: [],
      ccoTags: [],
      listarTemplates: [],
      baseUrl: store.state.baseUrlEmails,
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'ativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      itemPorPage: '100',
      fields: [
        { key: 'idemail', label: 'ID', sortable: true, active: true },
        { key: 'identificacao', label: 'Identificação', sortable: true, active: true },
        { key: 'assunto', label: 'Assunto', sortable: true, active: true },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        },
        {
          button: true,
          funcaoButton: 'viewField',
          icon: 'eye',
          tooltip: 'Visualizar mensagem',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  methods: {
    addTemplateEmail() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrl + 'Email/Inserir',
          this.editarTemplate,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listMensagemEmail()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'modal-edit' + this._uid)
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.callAlert('Erro', error.response.data, 'error', 'error')
          } else {
            this.setErrorSystem(error)
          }
        })
        .finally(this.carregaTexto)
    },
    editTemplateEmail() {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrl + 'Email/Alterar',
          this.editarTemplate,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listMensagemEmail()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'modal-edit' + this._uid)
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.callAlert('Erro', error.response.data, 'error', 'error')
          } else {
            this.setErrorSystem(error)
          }
        })
        .finally(this.carregaTexto)
    },
    submitTemplate() {
      if (this.editarTemplate.idtemplate == null) {
        this.callToast('Selecione um template!', 'error', 'error', 'center')
        return false
      }

      if (this.editarTemplate.mensagem == null || this.editarTemplate.mensagem.length === 0) {
        this.callToast('Preencha a mensagem!', 'error', 'error', 'center')
        return false
      }

      if (this.editarTemplate.idemail === 0) {
        this.addTemplateEmail()
      } else {
        this.editTemplateEmail()
      }
    },
    listMensagemEmail: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(this.baseUrl + 'Email/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listarMensagens = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    viewField(_, item) {
      axios
        .get(
          this.baseUrl + 'Template/VisualizarTemplate/' + item.idtemplate + '/' + item.idemail,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.showMensagem = response.data
        })
        .catch(this.setErrorSystem)
      this.$root.$emit('bv::show::modal', 'modal-view' + this._uid)
    },
    addField() {
      this.titleModal = 'Adicionar Mensagem'
      this.editarTemplate = {
        tpmanut: 'A',
        idemail: 0,
        copiapara: '',
        copiaocultapara: '',
        fila: true,
        ativo: true
      }
      this.ccTags = this.ccoTags = []
      this.showEditModal()
    },
    editField(_, item) {
      this.titleModal = 'Editar Mensagem'
      this.editarTemplate = item
      this.editarTemplate.copiapara = item.copiapara === undefined ? '' : item.copiapara
      this.editarTemplate.copiaocultapara =
        item.copiaocultapara === undefined ? '' : item.copiaocultapara
      this.ccTags = item.copiapara != null ? item.copiapara.split(';') : []
      this.ccoTags = item.copiaocultapara != null ? item.copiaocultapara.split(';') : []
      this.showEditModal()
    },
    showEditModal() {
      this.listTemplateEmail()
      this.$root.$emit('bv::show::modal', 'modal-edit' + this._uid)
    },
    deleteField(_, item) {
      this.callConfirm(this.mensagemExcluir + '?', 'Template: ' + item.identificacao).then(
        (result) => {
          if (result.value) {
            this.carregaTexto(this.codeMensagem('C02'))

            axios
              .delete(
                this.baseUrl + 'Email/Excluir/' + item.idemail,
                this.dadosLoginSession.fccTokenHeaders
              )
              .then(() => {
                this.listMensagemEmail()
                this.callToast(this.mensagensUpdate.excluido, 'success')
              })
              .catch(this.setErrorSystem)
              .finally(this.carregaTexto)
          }
        }
      )
    },
    listTemplateEmail: function () {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(this.baseUrl + 'Template/Listar', this.dadosLoginSession.fccTokenHeaders)
        .then((response) => {
          this.listarTemplates = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    changeStatus(_, item) {
      this.editarTemplate = item
      this.editarTemplate.copiapara = item.copiapara === undefined ? '' : item.copiapara
      this.editarTemplate.copiaocultapara =
        item.copiaocultapara === undefined ? '' : item.copiaocultapara
      this.editTemplateEmail()
    },
    converteCopia(values, cc = true) {
      if (cc) {
        this.editarTemplate.copiapara = values.map((val) => val.toLowerCase()).join(';')
      } else {
        this.editarTemplate.copiaocultapara = values.map((val) => val.toLowerCase()).join(';')
      }
    },
    validaEmail(val) {
      const regex = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      return regex.test(val.toLowerCase())
    }
  },
  mounted() {
    this.listMensagemEmail()
  }
}
</script>
